import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { robotsForPath, setRobots } from '@/lib/seo'

/**
 * Single source of truth for robots meta.
 * Marketing URLs stay indexable; legal pages are noindex but followed;
 * login, portals, and deep-link handlers are noindex so they do not
 * compete with the homepage.
 */
export default function RouteSeo() {
  const { pathname } = useLocation()

  useEffect(() => {
    setRobots(robotsForPath(pathname))
  }, [pathname])

  return null
}
